/**
 * Vuetify3 Plugin
 */
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';

import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { createVuetify } from 'vuetify';

// For test use. Do not include createVuetify()
// see https://vuetifyjs.com/en/features/treeshaking/
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// If you use Vuetify Labs
// https://vuetifyjs.com/en/labs/introduction/
import * as labs from 'vuetify/labs/components';

// Translations provided by Vuetify
import { en } from 'vuetify/locale';

// Misc
import { loadFonts } from './webfontloader';
import type { ThemeDefinition } from 'vuetify/lib/index.mjs';

await loadFonts();

/**
 * Vuetify Components
 *
 * Notice: This variable is used during development to load all components to speed up the display
 *         and to reduce the size during build.
 *
 * @see {@link https://vuetifyjs.com/en/labs/introduction/}
 */
const vuetifyComponents = import.meta.env.DEV
  ? {
      components: {
        ...components,
        ...labs,
      },
      directives,
    }
  : {
      components: {
        ...components,
        ...labs,
      },
    };

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    error: '#c71c3b',
    info: '#2196F3',
    success: '#65b32e',
    warning: '#FB8C00',
  },
};

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    error: '#de6666',
    info: '#2196F3',
    success: '#65b32e',
    warning: '#FB8C00',
  },
};

export default createVuetify({
  ...vuetifyComponents,
  // Global configuration
  // https://next.vuetifyjs.com/en/features/global-configuration/
  /*
  defaults: {
    global: {
      ripple: false,
    },
    VSheet: {
      elevation: 4,
    },
  },
  */
  // Icon Fonts
  // https://next.vuetifyjs.com/en/features/icon-fonts/
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  // Internationalization (i18n)
  // https://next.vuetifyjs.com/en/features/internationalization/#internationalization-i18n
  locale: {
    locale: 'en',
    fallback: 'en',
    messages: { en },
  },
  // Theme
  // https://next.vuetifyjs.com/en/features/theme/
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
});

// Export for test.
export { components, directives };
